import { Box } from '@osmosis/tailwind-ui/components/Box';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import { bg0 } from '@osmosis/tailwind-ui/styles/background';
import { FormattedMessage } from 'react-intl';

interface NotesPageInfoBlockProps {
  pageTitle: string;
}

/**
 * Displays the information block for the notes page, including the title and description.
 * @param {NotesPageInfoBlockProps} props - The props for the component.
 */
const NotesPageInfoBlock = ({ pageTitle }: NotesPageInfoBlockProps) => {
  return (
    <Box className={`my-2 p-4 ${bg0} rounded-md`}>
      <H3 className="border-b-[2px] pb-3">
        <FormattedMessage
          id="notesPage.info.title"
          defaultMessage="Osmosis High-Yield Notes"
        />
      </H3>
      <Box className="mt-2">
        <FormattedMessage
          id="notesPage.info.description"
          defaultMessage="This Osmosis High-Yield Note provides an overview of {pageTitle} essentials. All Osmosis Notes are clearly laid-out and contain striking images, tables, and diagrams to help visual learners understand complex topics quickly and efficiently. Find more information about {pageTitle}"
          values={{ pageTitle }}
        />
      </Box>
    </Box>
  );
};

export default NotesPageInfoBlock;
